module.exports = __webpack_public_path__ + "img/comentarios.24c46c44.svg";